"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("material-ui/TextField"));

var _RaisedButton = _interopRequireDefault(require("material-ui/RaisedButton"));

var _Checkbox = _interopRequireDefault(require("material-ui/Checkbox"));

var _MuiUploader = _interopRequireDefault(require("../shared/elements/imageUpload/MuiUploader"));

var _utils = require("../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var makeKey = function makeKey(prop) {
  return "companySignup.".concat(prop);
};

var AddCompanyInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(AddCompanyInfo, _React$Component);

  var _super = _createSuper(AddCompanyInfo);

  function AddCompanyInfo(props) {
    var _this;

    _classCallCheck(this, AddCompanyInfo);

    _this = _super.call(this, props);
    _this.state = {
      error: {},
      passVisible: false
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.getValue = _this.getValue.bind(_assertThisInitialized(_this));
    _this.getClass = _this.getClass.bind(_assertThisInitialized(_this));

    _this.getErrorText = function (key) {
      return props.getErrorText('companySignup', key);
    };

    return _this;
  }

  _createClass(AddCompanyInfo, [{
    key: "handleChange",
    value: function handleChange(prop) {
      return this.props.handleInputChange(prop, 'companySignup');
    }
  }, {
    key: "handlePhoneChange",
    value: function handlePhoneChange(prop) {
      return this.props.handlePhoneChange(prop, 'companySignup');
    }
  }, {
    key: "getValue",
    value: function getValue(prop) {
      return this.props.getValue(prop, 'companySignup');
    }
  }, {
    key: "getClass",
    value: function getClass(prop) {
      return this.props.getInputClass(makeKey(prop));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          prependProtocol = _this$props.prependProtocol,
          handleSaveCompany = _this$props.handleSaveCompany,
          analyticsPrefix = _this$props.analyticsPrefix,
          isInternal = _this$props.isInternal;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dash-page-card-content",
        onSubmit: handleSaveCompany
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: "admin-company-form standard-dash-form",
        ref: function ref(c) {
          _this2.initialHeight = c;
        }
      }, /*#__PURE__*/_react.default.createElement(_MuiUploader.default, {
        label: "Account Logo",
        image: this.getValue('logo'),
        handleUpload: this.handleChange('logo'),
        gaKey: "create-decedent-details-companyphoto",
        setCroppedImage: this.props.setCroppedImage,
        analyticsObject: {
          browse: "".concat(analyticsPrefix, "-browsephoto"),
          crop: "".concat(analyticsPrefix, "-cropphoto"),
          remove: "".concat(analyticsPrefix, "-removephoto")
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-single-field"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('name')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Corporation Name*",
        id: makeKey('name'),
        required: true,
        type: "text",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('name'),
        onChange: this.handleChange('name'),
        value: this.getValue('name')
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-two-fields"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('address.street1')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Address 1*",
        id: "address.street1",
        required: true,
        type: "text",
        hintText: "",
        className: "form-input street1",
        errorText: this.getErrorText('address.street1'),
        onChange: this.handleChange('address.street1'),
        value: this.getValue('address.street1')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('address.street2')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Address 2",
        id: "address.street2",
        type: "text",
        hintText: "",
        className: "form-input street2",
        onChange: this.handleChange('address.street2'),
        value: this.getValue('address.street2')
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-two-fields"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('address.city')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "City*",
        id: "address.city",
        required: true,
        type: "text",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('address.city'),
        onChange: this.handleChange('address.city'),
        value: this.getValue('address.city')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('address.state')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "State*",
        id: "address.state",
        required: true,
        type: "text",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('address.state'),
        onChange: this.handleChange('address.state'),
        value: this.getValue('address.state')
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-two-fields"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('address.zip')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Postal Code*",
        id: "address.zip",
        required: true,
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('address.zip'),
        onChange: this.handleChange('address.zip'),
        value: this.getValue('address.zip')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('phone')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Phone Number*",
        id: "phone",
        required: true,
        type: "tel",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('phone'),
        onChange: this.handlePhoneChange('phone'),
        value: this.getValue('phone')
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-two-fields"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('website')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Website*",
        id: "website",
        required: true,
        type: "url",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('website'),
        onChange: this.handleChange('website'),
        value: this.getValue('website'),
        onBlur: prependProtocol('companySignup', 'website')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('numberOfLocations')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Number of Locations",
        id: "numberOfLocations",
        required: true,
        type: "number",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('numberOfLocations'),
        onChange: this.handleChange('numberOfLocations'),
        value: this.getValue('numberOfLocations')
      }))), isInternal && /*#__PURE__*/_react.default.createElement("div", {
        className: "form-two-fields"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('sfRef')
      }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
        floatingLabelText: "Salesforce ID",
        id: "sfRef",
        hintText: "",
        className: "form-input",
        errorText: this.getErrorText('sfRef'),
        onChange: this.handleChange('sfRef'),
        value: this.getValue('sfRef')
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.getClass('isLegacyTouch')
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        name: "isLegacyTouch",
        label: "Legacy Touch",
        onCheck: this.handleChange('beta.legacyTouch'),
        checked: this.getValue('beta.legacyTouch') || false
      }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        name: "isPrecoaHome",
        label: "Precoa Account",
        onCheck: this.handleChange('beta.precoa'),
        checked: this.getValue('beta.precoa') || false
      }))), handleSaveCompany && /*#__PURE__*/_react.default.createElement(_RaisedButton.default, {
        label: "Save",
        className: "company-save",
        labelStyle: {
          textTransform: 'none'
        },
        type: "submit",
        primary: true,
        onClick: function onClick(e) {
          (0, _utils.googleAnalytics)("".concat(analyticsPrefix, "-save"))(e);
        },
        onKeyDown: _utils.preventTabKeyPress
      })));
    }
  }]);

  return AddCompanyInfo;
}(_react.default.Component);

exports.default = AddCompanyInfo;